import { debug } from '~/utils/logging'

export default function useLoginLinks() {
  const { locale } = useI18n()
  const {
    data,
    status,
    isAuthenticated,
    signIn: _signIn,
    signOut,
  } = useAuthLinks({
    locale,
  })

  const { dailyWordSubscribeUrl } = useAppConfig() as {
    dailyWordSubscribeUrl: Record<'en' | 'es', string>
  }

  const { isAllowed: isAllowedImpl } = usePermissions(PERMISSIONS.DAILY_WORD)
  const isAllowed = computed(() =>
    import.meta.dev ? unref(isAuthenticated) : unref(isAllowedImpl),
  )

  const subscribe = async () => {
    const lang = (locale.value || 'en') as 'en' | 'es'
    const path = dailyWordSubscribeUrl[lang]
    return await navigateTo(path, { external: true })
  }

  const canAccessDailyWord = computed(() => isAllowed.value)

  watch(status, (newVal, oldVal) => {
    debug(`[useLoginLinks] status changed from "${oldVal}" to "${newVal}"`)
  })

  const signIn = () => {
    debug('[useLoginLinks] signining in')
    _signIn()
  }

  return {
    data,
    isAuthenticated,
    canAccessDailyWord,
    signIn,
    signOut,
    subscribe,
  }
}
